import { render, staticRenderFns } from "./CardStaff.vue?vue&type=template&id=a97cbc24&scoped=true"
import script from "./CardStaff.vue?vue&type=script&lang=js"
export * from "./CardStaff.vue?vue&type=script&lang=js"
import style0 from "./CardStaff.vue?vue&type=style&index=0&id=a97cbc24&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97cbc24",
  null
  
)

export default component.exports